import { HttpClient, HttpParams } from '@angular/common/http';
import { ComponentFactoryResolver, Inject, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AppConfig, APP_CONFIG } from '../../app-config/app-config.module';
import { AncillaryReportRecord } from '../model/ancillary-report-record';
import { PatientSearchResult } from '../model/patient-search-result';
import { PersonResponsibilityRo } from '../model/person-responsibility-ro';
import { SearchCriteria } from '../model/search-criteria';
import { SearchInfo } from '../model/search-info';
import { SlotAvailabilityPreview } from '../model/slot-availability-preview';
import { SlotReservationPreviewRecord } from '../model/slot-reservation-preview-record';
import { StudyDosage } from '../model/study-dosage';
import { StudyPatientSearchResult } from '../model/study-patient-search-result';
import { StudyRecord } from './../model/study-record';
import { BaseService } from './base-service';




@Injectable()
export class SearchService extends BaseService {

    versionV2 = 'v2';
    http: HttpClient ;
    config: AppConfig;
    serviceUrlPrefix: string;
    serviceUrlPrefixV2: string;
    private version: string;


    /*
    * Queue that holds the search query criteria
    */
    private searchQuerySource = new Subject<SearchCriteria>();
    // Observable pendingHttp streams
    /**
     * Observable stream that returns the search query criteria
     */
    // eslint-disable-next-line @typescript-eslint/member-ordering
    searchQuery$ = this.searchQuerySource.asObservable();



//     /**
//    * variable for instance of ProtocolOrPatientSearch last executed
//    */
//     private _currentSearchQuery: SearchCriteria = { searchCriteria: null, searchTypeEnum: 0 };

//     /**
//      * returns the instance of the HomeSearchCriteria model last executed
//      */
//     public get currentSearchQuery(): SearchCriteria {
//         return this._currentSearchQuery;
//     }

//     /**
//      * sets the instance of the HomeSearchCriteria model last executed
//      */
//     public set currentSearchQuery(searchQuery: SearchCriteria) {
//         this._currentSearchQuery = searchQuery;
//     }


    private mappedSearchCriteria: Map<number, SearchInfo> = new Map<number, SearchInfo>();


    constructor(http: HttpClient,
        @Inject(APP_CONFIG) config: AppConfig,
        componentFactoryResolver: ComponentFactoryResolver) {
        super(componentFactoryResolver);
        this.config = config;
        this.http = http;
        this.serviceUrlPrefix = config.apiEndpoint;
        this.serviceUrlPrefixV2 = config.v2_apiEndpoint;
        this.version = config.version;
      }

    // Service message commands
    /**
     * Adds the next search criteria to be searched upon
     * @param searchQuery : the search query to be search upon
     */
    setSearchCriteria(searchQuery: SearchCriteria) {
        this.searchQuerySource.next(searchQuery);
    }


    /**
     * Sets the Search query for the the landing page
     * @param landingPageEnum The enum associated with the landing page
     * @param criteria the criteria to be saved for this page
     */
    setSearchQuery(landingPageEnum: number, criteria: SearchInfo) {
        this.mappedSearchCriteria.set(landingPageEnum, criteria);
    }

    /**
     * Returns the search criteria associated with this landing page if it exists
     * @param landingPageEnum The landing page enum for which the criteria needs to be pulled
     */
    getSearchQuery(landingPageEnum: number): SearchInfo {
        return this.mappedSearchCriteria.get(landingPageEnum);
    }

    /**
     * Clears out the search queries stored here
     */
    clearSearchQueries() {
      this.mappedSearchCriteria.clear();
      console.log('Mapped Search Criteria ', this.mappedSearchCriteria)
    }


    /**
     * Returns the list of studies that match the criteria
     * @param studyNumber The study number to search for
     */
    getStudy(studyNumber: string): Observable<StudyRecord[]> {
        // protocolUrlPrefix is the endpoint for protocols and is getting from the app-config file.
        if (this.version === this.versionV2) {
            return this.http.get<StudyRecord[]>
            (this.serviceUrlPrefixV2 + 'studies?studyNumber=' + studyNumber);
        } else {
            return this.http.get<StudyRecord[]>
            (this.serviceUrlPrefix + 'studies?studyNumber=' + studyNumber);
        }

    }

    /**
     * Returns the response from searching patient Id
     * @param patientId The patient Id to search
     */
    getPatient(patientId: string, trackingNumber: string): Observable<PatientSearchResult[]> {

        let params;
        if(patientId) {
           params = {
                    'patientId' : patientId
                    }
        }
        if(trackingNumber) {
            params = {
                     'trackingNumber' : trackingNumber
                     }
         }

        if (this.version === this.versionV2) {
            return this.http.get<PatientSearchResult[]>
            (this.serviceUrlPrefixV2 + 'patients/search', {params: params});
        } else {
            return this.http.get<PatientSearchResult[]>
            (this.serviceUrlPrefix + 'patients/search', {params: params});
        }

    }

    /**
     * This will fetch the active patients for a specific study.
     * @param  number studyId - studyId
     * @returns Observable - return the active patients list.
     */
    getActivePatients(studyId: number): Observable<StudyPatientSearchResult[]> {
        return this.http.get<StudyPatientSearchResult[]>(this.serviceUrlPrefix + 'studies/' + studyId + '/patients/active');
    }



    // getAccrualPatientCount(studyId: number): Observable<> {
    //     let result: PatientSearchResult[] = [{ "patientId": "ex210981", "studyId": 12623, "studyNumber": "MC12569", "caseDetailId": 549, "firstName": "F", "middleName": "", "lastName": "", "dateOfBirth": null, "genderDesc": "Female", "raceDescList": ["American Indian/Alaskan Native"] }, { "patientId": "ex211000", "studyId": 11989, "studyNumber": "MC334455", "caseDetailId": 638, "firstName": "b", "middleName": "d", "lastName": "e", "dateOfBirth": null, "genderDesc": "Male Gender", "raceDescList": ["American Indian/Alaskan Native"] }, { "patientId": "ex211006", "studyId": 13112, "studyNumber": "8080", "caseDetailId": 708, "firstName": "test", "middleName": "", "lastName": "", "dateOfBirth": null, "genderDesc": null, "raceDescList": ["American Indian/Alaskan Native"] }, { "patientId": "ex210989", "studyId": 11989, "studyNumber": "MC334455", "caseDetailId": 564, "firstName": "T", "middleName": "A", "lastName": "G", "dateOfBirth": new Date("1980-02-02"), "genderDesc": "Unknown", "raceDescList": ["Other"] }, { "patientId": "ex210993", "studyId": 11989, "studyNumber": "MC334455", "caseDetailId": 572, "firstName": "P", "middleName": "L", "lastName": "K", "dateOfBirth": new Date("1980-02-03", )"genderDesc": "Unknown", "raceDescList": ["Other"] }, { "patientId": "ex210994", "studyId": 11989, "studyNumber": "MC334455", "caseDetailId": 586, "firstName": "K", "middleName": "I", "lastName": "Y", "dateOfBirth": null, "genderDesc": "Unknown", "raceDescList": ["Choose Not to Disclose"] }, { "patientId": "ex210996", "studyId": 11989, "studyNumber": "MC334455", "caseDetailId": 590, "firstName": "O", "middleName": "I", "lastName": "L", "dateOfBirth": null, "genderDesc": "Unknown", "raceDescList": ["Choose Not to Disclose"] }, { "patientId": "ex211001", "studyId": 13411, "studyNumber": "BD-1", "caseDetailId": 650, "firstName": "b", "middleName": "b", "lastName": "b", "dateOfBirth": null, "genderDesc": "Female", "raceDescList": ["American Indian or Alaskan Native"] }, { "patientId": "ex211005", "studyId": 13411, "studyNumber": "BD-1", "caseDetailId": 697, "firstName": "b", "middleName": "b", "lastName": "b", "dateOfBirth": null, "genderDesc": "Female", "raceDescList": ["American Indian or Alaskan Native"] }, { "patientId": "ex211007", "studyId": 13411, "studyNumber": "BD-1", "caseDetailId": 721, "firstName": "a", "middleName": "a", "lastName": "a", "dateOfBirth": null, "genderDesc": "Female", "raceDescList": ["American Indian or Alaskan Native"] }, { "patientId": "ex211009", "studyId": 13411, "studyNumber": "BD-1", "caseDetailId": 730, "firstName": "c", "middleName": "c", "lastName": "c", "dateOfBirth": null, "genderDesc": "Female", "raceDescList": ["American Indian or Alaskan Native"] }, { "patientId": "ex211010", "studyId": 13411, "studyNumber": "BD-1", "caseDetailId": 733, "firstName": "d", "middleName": "d", "lastName": "d", "dateOfBirth": null, "genderDesc": "Male", "raceDescList": ["American Indian or Alaskan Native"] }, { "patientId": "ex211011", "studyId": 13411, "studyNumber": "BD-1", "caseDetailId": 735, "firstName": "F", "middleName": "F", "lastName": "F", "dateOfBirth": null, "genderDesc": "Female", "raceDescList": ["American Indian or Alaskan Native"] }, { "patientId": "ex211013", "studyId": 13411, "studyNumber": "BD-1", "caseDetailId": 797, "firstName": "b", "middleName": "m", "lastName": "f", "dateOfBirth": null, "genderDesc": "Female", "raceDescList": ["American Indian or Alaskan Native"] }, { "patientId": "ex211014", "studyId": 13411, "studyNumber": "BD-1", "caseDetailId": 798, "firstName": "b", "middleName": "b", "lastName": "b", "dateOfBirth": null, "genderDesc": "Female", "raceDescList": ["Black or African American"] }, { "patientId": "ex211002", "studyId": 13411, "studyNumber": "BD-1", "caseDetailId": 652, "firstName": "Test", "middleName": "Middle", "lastName": "Last", "dateOfBirth": null, "genderDesc": "Unknown", "raceDescList": ["White"] }, { "patientId": "ex211004", "studyId": 13411, "studyNumber": "BD-1", "caseDetailId": 682, "firstName": "Test 1", "middleName": "Mid Test", "lastName": "Test Last", "dateOfBirth": null, "genderDesc": "Blank", "raceDescList": ["Unknown: Patient unsure", "Not reported: patient refused or not available"] }, { "patientId": "ex211003", "studyId": 13411, "studyNumber": "BD-1", "caseDetailId": 681, "firstName": "First Name ", "middleName": "Test", "lastName": "Last", "dateOfBirth": null, "genderDesc": "Blank", "raceDescList": ["Not reported: patient refused or not available"] }, { "patientId": "ex211008", "studyId": 13411, "studyNumber": "BD-1", "caseDetailId": 729, "firstName": "FN", "middleName": "MN", "lastName": "LN", "dateOfBirth": null, "genderDesc": "Female", "raceDescList": ["Not reported: patient refused or not available"] }, { "patientId": "ex211012", "studyId": 13526, "studyNumber": "MC3333", "caseDetailId": 739, "firstName": "", "middleName": "", "lastName": "", "dateOfBirth": null, "genderDesc": null, "raceDescList": [null] }, { "patientId": "ex210988", "studyId": 11989, "studyNumber": "MC334455", "caseDetailId": 562, "firstName": "", "middleName": "", "lastName": "", "dateOfBirth": null, "genderDesc": null, "raceDescList": [null] }, { "patientId": "ex210990", "studyId": 11989, "studyNumber": "MC334455", "caseDetailId": 568, "firstName": "", "middleName": "", "lastName": "", "dateOfBirth": null, "genderDesc": null, "raceDescList": [null] }, { "patientId": "ex210980", "studyId": 11989, "studyNumber": "MC334455", "caseDetailId": 548, "firstName": "", "middleName": "", "lastName": "", "dateOfBirth": null, "genderDesc": null, "raceDescList": [null] }, { "patientId": "ex210982", "studyId": 11989, "studyNumber": "MC334455", "caseDetailId": 559, "firstName": "", "middleName": "", "lastName": "", "dateOfBirth": null, "genderDesc": null, "raceDescList": [null] }, { "patientId": "ex210983", "studyId": 11989, "studyNumber": "MC334455", "caseDetailId": 560, "firstName": "", "middleName": "", "lastName": "", "dateOfBirth": null, "genderDesc": null, "raceDescList": [null] }, { "patientId": "ex210995", "studyId": 12623, "studyNumber": "MC12569", "caseDetailId": 577, "firstName": "xyz", "middleName": "", "lastName": "", "dateOfBirth": null, "genderDesc": null, "raceDescList": [null] }, { "patientId": "ex210997", "studyId": 11989, "studyNumber": "MC334455", "caseDetailId": 594, "firstName": "X", "middleName": "", "lastName": "", "dateOfBirth": null, "genderDesc": null, "raceDescList": [null] }, { "patientId": "ex210998", "studyId": 11989, "studyNumber": "MC334455", "caseDetailId": 600, "firstName": "", "middleName": "", "lastName": "", "dateOfBirth": null, "genderDesc": null, "raceDescList": [null] }, { "patientId": "ex210991", "studyId": 11989, "studyNumber": "MC334455", "caseDetailId": 558, "firstName": "", "middleName": "", "lastName": "", "dateOfBirth": null, "genderDesc": null, "raceDescList": [null] }, { "patientId": "ex210999", "studyId": 12623, "studyNumber": "MC12569", "caseDetailId": 601, "firstName": "", "middleName": "", "lastName": "", "dateOfBirth": null, "genderDesc": null, "raceDescList": [null] }, { "patientId": "ex210992", "studyId": 11989, "studyNumber": "MC334455", "caseDetailId": 569, "firstName": "", "middleName": "", "lastName": "", "dateOfBirth": null, "genderDesc": null, "raceDescList": [null] }, { "patientId": "ex210986", "studyId": 11989, "studyNumber": "MC334455", "caseDetailId": 561, "firstName": "", "middleName": "", "lastName": "", "dateOfBirth": null, "genderDesc": null, "raceDescList": [null] }];
    //     return of(result);
    // }

    /**
     * Returns the list of patients currently accrued for this study
     * returns one record for every event patient is registered to
     */
    getAccruedPatients(studyId: number, patientId: string): Observable<StudyPatientSearchResult[]> {
       let patientIdSearchParameter = '';
        if (patientId !== '') {
            patientIdSearchParameter = '?patientId=' + patientId
        }
        // http://r5073618:8080/reg-backend-service/api/v1/studies/9500/patients
        return this.http.get<StudyPatientSearchResult[]>
        (this.serviceUrlPrefix + 'studies/' + studyId + '/patients' + patientIdSearchParameter);

    }


    /**
     * This will fetch the contacts for a specific study.
     * @param  number studyId - studyId
     * @returns Observable - return the contacts list.
     */
    getContacts(studyId: number): Observable<PersonResponsibilityRo[]> {
        //    [{"pk":143,"firstName":"Harshitha","lastName":"Rai","status":"Active","roleDescription":"Medical Monitor","email":"Rai.Harshitha@mayo.edu","phone":null},{"pk":183,"firstName":"Barbara","lastName":"Dobie","status":"Active","roleDescription":"Statistician","email":"Dobie.Barbara@mayo.edu","phone":"123-1234-4444"}]
        const url: string = 'studies/' + studyId + '/study-team?state=Active'
        return this.http.get<PersonResponsibilityRo[]>(this.serviceUrlPrefixV2 + url);
    }


        /**
     * This will fetch the ancillary studies for a specific study.
     * @param  number studyId - studyId
     * @returns Observable - return list of ancillary studies
     */
    getAncillaryStudies(studyId: number): Observable<AncillaryReportRecord[]> {
        const url: string = 'studies/' + studyId + '/ancillary'
        return this.http.get<AncillaryReportRecord[]>(this.serviceUrlPrefix + url);
    }

    /**
     * This will fetch the dosage for a specific study.
     * @param  number studyId - studyId
     * @returns Observable - return the dosage list.
     */
    getDosages(studyId: number): Observable<StudyDosage[]> {
        const url: string = 'studies/' + studyId + '/dosages'
        return this.http.get<StudyDosage[]>(this.serviceUrlPrefix + url);
    }

        /**
     * This will fetch the slot reservations for a specific study.
     * @param  number studyId - studyId
     * @returns Observable - return the slot reservation list.
     */
     getSlotReservations(studyId: number): Observable<SlotReservationPreviewRecord[]> {
        const url: string = 'studies/' + studyId + '/reservations'
        return this.http.get<SlotReservationPreviewRecord[]>(this.serviceUrlPrefix + url);
        }

    /**
     * This will fetch the slot availability for studdy
     * @param  studyId - studyId
     * @returns Observable - return the slot availability information
     */
    getSlotAvailability(studyId: number): Observable<SlotAvailabilityPreview> {
        const url: string = 'studies/' + studyId + '/reservations/slot-availability'
        return this.http.get<SlotAvailabilityPreview>(this.serviceUrlPrefix + url);
    }

    /**
   * Convert to date type for sorting
   * @param dateString 
   * @returns 
   */
  parseDateString(dateString: string): Date | string {
    if (dateString) {
        const dateParts = dateString.split("/");
        if (dateParts.length === 3) {
            return new Date(Number(dateParts[2]), Number(dateParts[0]) - 1, Number(dateParts[1]));
        }
    }
    //If date is empty/null then returing old date to sort in correct order.
    return new Date("1900-01-01"); 
  }

}
